import { CONSOLIDACAO_TIPO } from '@investirapri/financa.js/lib/enums';
import { dates, validators } from 'investira.sdk';

const wAtivoPatrimonioOptionPriority = [
  CONSOLIDACAO_TIPO.CNS.id,
  CONSOLIDACAO_TIPO.CNSPRD.id,
  CONSOLIDACAO_TIPO.CNSFNC.id,
  CONSOLIDACAO_TIPO.IND.id
];

export const ATIVO_PATRIMONIO_METRIC_TYPE = {
  pl: 'pl',
  cotistas: 'cotistas'
};

/**
 * Retorna a descrição patrimonial conforme o enquadramento da entidade.
 */
export const getAtivoPatrimonioDescription = (pPessoa = {}) => {
  return pPessoa?.setor_id === '65.41.3.00' ? 'Patrimônio Social' : 'Patrimônio Líquido';
};

/**
 * Extrai as opções válidas de consolidação preservando a ordem recebida.
 */
export const getAtivoPatrimonioOptions = (pData = []) => {
  const xOptions = new Set();

  pData.forEach(pItem => {
    const xOption = pItem?.consolidacao_tipo;

    if (xOption !== null && typeof xOption !== 'undefined' && xOption !== '') {
      xOptions.add(xOption);
    }
  });

  return Array.from(xOptions);
};

/**
 * Escolhe a consolidação inicial priorizando as opções da primeira pessoa.
 */
export const getAtivoPatrimonioInitialOption = (pPrimaryOptions = [], pOptions = []) => {
  const xOptions = pPrimaryOptions.length ? pPrimaryOptions : pOptions;
  const xPriorityOption = wAtivoPatrimonioOptionPriority.find(pOption =>
    xOptions.includes(pOption)
  );

  return xPriorityOption ?? xOptions[0] ?? null;
};

/**
 * Consolida uma métrica por mês sem substituir um valor válido por um registro nulo posterior.
 */
const pvGetAtivoPatrimonioMonthlyData = (pData = [], pGetValue) => {
  const xMonthlyMap = new Map();

  pData.forEach(pItem => {
    const xPointDate = dates.toDate(pItem.data);
    const xMonthKey = `${xPointDate.getFullYear()}-${xPointDate.getMonth()}`;
    const xCurrentValue = pGetValue(xMonthlyMap.get(xMonthKey));
    const xNextValue = pGetValue(pItem);

    if (validators.isNull(xNextValue) && !validators.isNull(xCurrentValue)) {
      return;
    }

    xMonthlyMap.set(xMonthKey, pItem);
  });

  const xData = Array.from(xMonthlyMap.values()).map(pItem => [
    dates.startOf('month', dates.toDate(pItem.data)).getTime(),
    pGetValue(pItem)
  ]);
  const xHasData = xData.some(([, pValue]) => !validators.isNull(pValue));

  return xHasData ? xData : [];
};

/**
 * Consolida o patrimônio por mês mantendo o último valor válido.
 */
export const getAtivoPatrimonioPlData = (pData = []) => {
  return pvGetAtivoPatrimonioMonthlyData(pData, pItem => pItem?.pl);
};

/**
 * Consolida os cotistas por mês mantendo o último valor válido.
 */
export const getAtivoPatrimonioCotistasData = (pData = []) => {
  return pvGetAtivoPatrimonioMonthlyData(pData, pItem => pItem?.fundo?.cotistas);
};

/**
 * Retorna o valor e a data mais recentes disponíveis para a métrica selecionada.
 */
export const getAtivoPatrimonioCurrentMetricInfo = (
  pData = [],
  pMetric = ATIVO_PATRIMONIO_METRIC_TYPE.pl
) => {
  const xCurrentPoint = [...pData].reverse().find(pItem => {
    const xValue =
      pMetric === ATIVO_PATRIMONIO_METRIC_TYPE.cotistas ? pItem?.fundo?.cotistas : pItem?.pl;

    return !validators.isNull(xValue);
  });

  if (!xCurrentPoint) {
    return { valor: null, data: null };
  }

  return {
    valor:
      pMetric === ATIVO_PATRIMONIO_METRIC_TYPE.cotistas
        ? xCurrentPoint?.fundo?.cotistas
        : xCurrentPoint?.pl,
    data: xCurrentPoint.data || null
  };
};
